import { render, staticRenderFns } from "./jwb.vue?vue&type=template&id=55215ea8&scoped=true"
import script from "./jwb.vue?vue&type=script&lang=js"
export * from "./jwb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55215ea8",
  null
  
)

export default component.exports